import { render } from "./Equipamentos.vue?vue&type=template&id=10405161&scoped=true"
import script from "./Equipamentos.vue?vue&type=script&lang=js"
export * from "./Equipamentos.vue?vue&type=script&lang=js"

import "./Equipamentos.vue?vue&type=style&index=0&id=10405161&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10405161"]])

export default __exports__